import { BaseChartGenerator } from '@/core/charts/baseChart.service'
import { IChartGenerator } from '@/core/charts/ichartgenerator.model'

class GaugeChart extends BaseChartGenerator implements IChartGenerator {
}

export default new GaugeChart()
